import { useEffect } from "react";

export function useResetListener(resetFunction: () => void) {
  useEffect(() => {
    const handler = () => resetFunction();
    window.addEventListener("resetAll", handler);

    return () => {
      window.removeEventListener("resetAll", handler);
    };
  }, [resetFunction]);
}
